<style>
    .migas {
        display: flex;
        margin: var(--padding-global) 0;
    }

    :global(.migas + h1) {
        margin-top: -.25em;
    }
</style>

<div class="migas">
    <slot />
</div>